<template>
  <div>

    <vs-popup-custom
      :id="cardId"
      class="vs-con-loading__container"
      :title="$t('edit_direct') | capitalize"
      :buttonCloseHidden="buttonCloseHidden"
      :active.sync="popupActive"
      :persistent="true"
    >
    <div id="directModal" class="vs-con-loading__container">
      <vs-row class="mb-4" >
        <vs-col
          vs-xs="4"
          vs-sm="3"
          vs-md="3"
          vs-lg="3"
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
        >
          <label>{{ $t('position') | capitalize }}</label>
        </vs-col>
        <vs-col
          vs-xs="8"
          vs-sm="9"
          vs-md="9"
          vs-lg="9"
          vs-type="flex"
          vs-justify="start"
          vs-align="start"
        >
          <vs-input class="w-full" :disabled="true" v-model="this.position" />
        </vs-col>
      </vs-row>
      <vs-row class="mb-4">
        <vs-col
          vs-xs="4"
          vs-sm="3"
          vs-md="3"
          vs-lg="3"
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
        >
          <label>{{ $t('department') | capitalize }}</label>
        </vs-col>
        <vs-col
          vs-xs="8"
          vs-sm="9"
          vs-md="9"
          vs-lg="9"
          vs-type="flex"
          vs-justify="start"
          vs-align="start"
        >
          <vs-input class="w-full" :disabled="true" v-model="this.department" />
        </vs-col>
      </vs-row>
      <vs-row class="mb-4">
        <vs-col
          vs-xs="4"
          vs-sm="3"
          vs-md="3"
          vs-lg="3"
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
        >
          <label>{{ $t('shift') | capitalize }}</label>
        </vs-col>
        <vs-col
          vs-xs="8"
          vs-sm="9"
          vs-md="9"
          vs-lg="9"
          vs-type="flex"
          vs-justify="start"
          vs-align="start"
        >
          <vs-input class="w-full" :disabled="true" v-model="this.shift" />
        </vs-col>
      </vs-row>
      <vs-row class="mb-4">
        <vs-col
          vs-xs="4"
          vs-sm="3"
          vs-md="3"
          vs-lg="3"
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
        >
          <label>{{ $t('headcount') | capitalize }}</label>
        </vs-col>
        <vs-col
          vs-xs="2"
          vs-sm="3"
          vs-md="3"
          vs-lg="3"
          vs-type="flex"
          vs-justify="start"
          vs-align="start"
        >
          <vs-input class="w-full" :disabled="true" v-model="this.headcount" />
        </vs-col>
        <vs-col
          vs-xs="4"
          vs-sm="3"
          vs-md="3"
          vs-lg="3"
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
        >
          <label>{{ $t('required') | capitalize }}</label>
        </vs-col>
        <vs-col
          vs-xs="2"
          vs-sm="3"
          vs-md="3"
          vs-lg="3"
          vs-type="flex"
          vs-justify="start"
          vs-align="start"
        >
          <vs-input
            class="w-full"
            autocomplete="NoCompletar"
            v-model="required"
            type="number"
          />
        </vs-col>
      </vs-row>
      <vs-row class="mb-4">
        <vs-col
          vs-xs="4"
          vs-sm="3"
          vs-md="3"
          vs-lg="3"
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
        >
          <label>{{ $t('comments') | capitalize }}</label>
        </vs-col>
        <vs-col
          vs-xs="8"
          vs-sm="9"
          vs-md="9"
          vs-lg="9"
          vs-type="flex"
          vs-justify="start"
          vs-align="start"
        >
          <vs-textarea
            class="w-full"
            autocomplete="NoCompletar"
            v-model="comments"
            maxlength="250"
          />
        </vs-col>
      </vs-row>
      <vs-row class="mb-4">
        <vs-col
          vs-xs="12"
          vs-sm="12"
          vs-md="12"
          vs-lg="12"
          vs-type="flex"
          vs-justify="end"
          vs-align="end"
        >
          <vs-button type="filled" @click="closeModal" class="mx-2" :disabled="this.activado==false">
            {{ $t('cancel') | capitalize }}
          </vs-button>

          <vs-button class="mx-2" :disabled="this.department == '' || this.required == '' || this.activado==false"  @click="guardar">
            {{ $t('save') | capitalize }}
          </vs-button>
        </vs-col>
      </vs-row>
      </div>
    </vs-popup-custom>
  </div>
</template>
<script>
import VsPopupCustom from '@/views/components/modals/VsPopupCustom.vue'
import dashboard from '@/http/requests/dashboard'
export default {
  name: 'direct-required-modal',
  components: {
    VsPopupCustom,
  },
  props: {
    directId: {
      type: [String,Number]
    },
  },
  data() {
    return {
      buttonCloseHidden:true,
      cardId: 'loading-direct-required-modal',
      loading: false,
      popupActive: false,
      activado: true,
      position: '',
      department: '',
      shift: '',
      headcount: '',
      required: '',
      comments: '',
    }
  },
  methods: {
    open() {
      this.popupActive = true;
    },
    closeModal(){
      this.popupActive = false
    },
    getData() {
      this.activado = true,
      this.position= ''
      this.department= ''
      this.shift= ''
      this.headcount= ''
      this.required= ''
      this.comments= ''
      this.loading = true
      dashboard
        .directShow(this.directId)
        .then((res) => {
            this.position = res.data.data.position
            this.department = res.data.data.name
            this.shift = res.data.data.shift
            this.headcount = res.data.data.headcount
            this.required = res.data.data.required
            this.comments = res.data.data.comments
        })
        .catch((err) => {
          console.log(err)
          this.loading = false
        })
      this.loading = false
    },
    guardar() {
      this.activado = false,
      this.loading = true
      let datos = {
        required:this.required,
        comments:this.comments 
      }
       dashboard
        .directUpdate(this.directId, datos)
        .then((res) => {
            this.activado = false,
            this.popupActive= false
            this.position= ''
            this.department= ''
            this.shift= ''
            this.headcount= ''
            this.required= ''
            this.comments= ''
            this.$emit('refresh')
        })
        .catch((err) => {
          console.log(err)
          this.activado = true,
          this.loading = false
        })
      this.loading = false
    },
  },
  watch: {
    loading(val) {
      if (val) {
        this.$vs.loading({
          container: `#loading-directModal`,
          scale: 0.45,
        })
      } else {
        this.$vs.loading.close(`#loading-directModal > .con-vs-loading`)
      }
    },
    popupActive(val){
      if(val){
        this.getData()
      }
    }
  },
}
</script>